<template>
<div>
  <v-flex class="text-black glosario" text-xs-center>
    <div v-for="(item,index) in items">
      <span class="name font-red">{{item.name}}</span>
      <br>
      <!-- Cambiar youtubeEmbed por videoEmbed cuando se inserten los videos -->
      <ui-simple-lsc v-if="glosario" :id="'video'+index" :videoglosario="true" :videoId="index" :active="item.videoAcc" @hideVideo="hideVideo" :vidTittle="item.name" :videoEmbed="item.link"></ui-simple-lsc>
      <span class="definition"><p>{{item.definition}}</p></span>
    </div>
  </v-flex>
  <v-flex xs12 text-xs-center justify-center="">
    <a href="https://misfinanzasencasa.davivienda.com/diccionario-financiero" target="_blank">
      <v-layout class="BotonDic hvr-grow" text-xs-center align-center="">
        <v-flex sm2>
          <image-app imaSrc="logos-icons/glosarioIcono" imaAlt=""></image-app>
        </v-flex>
        <v-flex sm10>
          <div>Diccionario<br>Financiero</div>
          <span></span>
        </v-flex>
      </v-layout>
    </a>
  </v-flex>
</div>
</template>

<script>
export default {
  props: {
    glosario: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      activeItem: -1,
      items: [{
          name: "ACTIVOS",
          definition: "Son los bienes y/o derechos de propiedad de un ente económico llamado persona natural o persona jurídica.",
          link: '01activos.mp4',
          videoAcc: false
        },
        {
          name: "AHORRO",
          definition: "Es la parte del ingreso que no se gasta, es decir, que voluntariamente se guarda para su uso futuro. Es una acción que consiste en guardar dinero en el presente para utilizarlo en el futuro.",
          link: '02ahorro.mp4',
          videoAcc: false
        },
        {
          name: "ENDEUDAMIENTO",
          definition: "Es la acción de obtener recursos de un tercero a través de una deuda con este.",
          link: '10endeudamiento.mp4',
          videoAcc: false
        },
        {
          name: "FIDUCIA",
          definition: "Acto jurídico mediante el cual, a través de un contrato, una persona natural o jurídica entrega a una fiduciaria unos bienes para que los administre con un fin determinado.",
          link: '11fiducia.mp4',
          videoAcc: false
        },
        {
          name: "FLUJO DE CAJA",
          definition: "Método a través del cual se determina la cantidad de ingresos y egresos efectivamente recibidos y realizados por un ente económico. En otras palabras, el movimiento del dinero al interior del ente económico.",
          link: '12flujodecaja.mp4',
          videoAcc: false
        },
        {
          name: "FINANZAS",
          definition: "Estudio de la asignación óptima de los recursos financieros y la toma de decisiones en escenarios de incertidumbre.",
          link: '13finanzas.mp4',
          videoAcc: false
        },
        {
          name: "GASTO",
          definition: "Es la cantidad de dinero que debe hacerse cuando se adquiere un producto o servicio.",
          link: '16gasto.mp4',
          videoAcc: false
        },
        {
          name: "IMPUESTO",
          definition: "Obligación de carácter público, y de todo aquel con capacidad económica, de dar una suma de dinero para satisfacer las necesidades económicas del Estado. Debe entenderse que el tributo es el género. Los impuestos, como las contribuciones y las tasas, son la especie.",
          link: '18impuesto.mp4',
          videoAcc: false
        },
        {
          name: "INGRESO",
          definition: "Cantidad de dinero que recibe una persona natural o jurídica por la venta de sus productos o servicios.",
          link: '19ingreso.mp4',
          videoAcc: false
        },
        {
          name: "META",
          definition: "Objetivos o propósitos de una persona.",
          link: '21meta.mp4',
          videoAcc: false
        },

        {
          name: "PATRIMONIO",
          definition: "Es el conjunto de los bienes y derechos pertenecientes a una persona, natural o jurídica.",
          link: '23patrimonio.mp4',
          videoAcc: false
        },
        {
          name: "PRESUPUESTO",
          definition: "Es una herramienta que ayuda a organizar el dinero para ser utilizado de una forma óptima y se convierte en un plan de acción dirigido a cumplir una meta prevista expresada en valores y términos financieros. Se construye registrando los ingresos y los gastos de un periodo de tiempo determinado.",
          link: '24presupuesto.mp4',
          videoAcc: false
        },
        {
          name: "SEGURO",
          definition: "Producto financiero que cubre riesgos de pérdida material o de la integridad de la vida humana a cambio del pago de cuotas anuales o mensuales, llamadas primas, que cubren los riesgos deseados.",
          link: '25seguro.mp4',
          videoAcc: false
        },
      ]
    };
  },
  methods: {
    hideVideo(video, id) {
      if(this.activeItem==-1){// Si no hay ningún video activo designa el nuevo video como video activo
        this.activeItem=id;
        this.items[id].videoAcc = video //video siempre es true para el glosario
      }else if(this.activeItem == id){// Si la acción es en el video que está observando
        this.items[id].videoAcc = !this.items[id].videoAcc
      }else{ 
        if(video){
          //Desactivar video en curso
          this.items[this.activeItem].videoAcc = false            

          //Activar nuevo video
          this.activeItem=id;
          this.items[id].videoAcc = video
        }
      }
    },
    closeVideos(){
      this.items.forEach(function(item){
        item.videoAcc = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";

.dark .name {
    color: $secondary-red;
}

.glosario {
    text-align: left;
    font-size: 1.3em;

    li {
        margin: 15px 0;

        .name {
            font-weight: bold;
            text-transform: uppercase;
        }

        .definition {
            text-transform: lowercase;
        }
    }
}
a {
    max-width: 150px;
    text-decoration: none;
    display: block;
    margin: auto;
    .BotonDic {
        width: 170px;
        padding: 0 5px;
        border-radius: 1%;
        color: #666666;
        background: linear-gradient(#7B7B7B,#666666);
        div {
            // font-size: 110
            text-align: left;
            margin-left: 0.5em;
            top: -1em;
            color: rgb(255, 255, 255) !important;
            text-decoration: none;
            line-height: 1em;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Glosario.vue?d2b0e72c